export const APP_ID = 'version-panel';
export const VERSION_PREFIX = 'VERSION-' as const;
export const ANALYTICS_SOURCE_VERSION_PANEL = 'version-panel' as const;
export const PACKAGE_NAME = 'jiraSoftwareVersionBacklogPanelRelay';
